import { Header } from '@/components/Layout/Header/Header';
import { useEvaluation } from '@/components/Views/Evaluation/Evaluation.hook';
import { EvaluationEmpty } from '@/components/Views/Evaluation/EvaluationEmpty';
import { EvaluationList } from '@/components/Views/Evaluation/EvaluationList';
import { useEvaluationStore } from '@/store/EvaluationStore/EvaluationStore';
import { FadeLoader } from 'react-spinners';
import { EvaluationForm } from '@/components/Views/Evaluation/EvaluationForm';

export const Evaluation = () => {
  const { exerciceTabs } = useEvaluationStore();
  const { lesson, loadingExercises } = useEvaluation();

  return (
    <>
      <Header title={`Evaluation : ${lesson ? lesson?.name : ''}`} goBack />
      {loadingExercises ? (
        <div className="flex justify-center items-center h-screen">
          <FadeLoader color="#FEC200" />
        </div>
      ) : (
        <>
          {exerciceTabs.length > 0 ? <EvaluationList /> : <EvaluationEmpty />}
        </>
      )}
      <EvaluationForm />
    </>
  );
};
